import { DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { filter, Subscription } from 'rxjs';
import { CurrentContextService } from '../../core/context/current-context.service';
import { LiveUpdateEventTypes, inventoryOperationsTopic } from '../../core/live-updates/live-update.models';
import { LiveUpdateService } from '../../core/live-updates/live-update.service';

export type InventoryLiveUpdatesDeps = {
  liveUpdateService: LiveUpdateService;
  contextService: CurrentContextService;
  destroyRef: DestroyRef;
};

export function bindInventoryLiveUpdates(
  deps: InventoryLiveUpdatesDeps,
  reload: (showLoading?: boolean) => void
): void {
  const { liveUpdateService, contextService, destroyRef } = deps;
  const subscriptionState = { topic: '' };

  const subscription: Subscription = liveUpdateService.events$
    .pipe(
      filter(event => event.eventType === LiveUpdateEventTypes.inventoryOperationsChanged),
      takeUntilDestroyed(destroyRef)
    )
    .subscribe(() => reload(false));

  destroyRef.onDestroy(() => {
    subscription.unsubscribe();
    if (subscriptionState.topic) {
      void liveUpdateService.unsubscribe(subscriptionState.topic);
    }
  });

  const tenantId = contextService.context()?.tenantId;
  if (tenantId) {
    subscriptionState.topic = inventoryOperationsTopic(tenantId);
    void liveUpdateService.subscribe(subscriptionState.topic);
  }
}
